import { apolloClient } from '@td/ui';
import CREATE_OR_UPDATE_PROVIDER_RELATION from '../mutations/create_or_update_provider_relation.graphql';

export const createOrUpdateProviderRelation = async (collPhysicianId, physicianId, state) => {
  const { data } = await apolloClient.mutate({
    mutation: CREATE_OR_UPDATE_PROVIDER_RELATION,
    variables: {
      collaboratingPhysicianId: collPhysicianId,
      physicianId: physicianId,
      stateCd: state,
    },
  });

  return data.createOrUpdateProviderRelation;
};

export default createOrUpdateProviderRelation;
